module.exports = __webpack_public_path__ + "static/media/DancingScript.d3bebba9.ttf";